import StudentDashboard from "./StudentDashboard";
import { useAuth } from "../../../authContext";
import usePageTitle from "common/usePageTitle";
import PrincipalDashboard from "./PrincipalDashboard/PrincipalDashboard";
import AccountantDashboardLessons from "./AccountantDashboardLessons";
import TeacherDashboardLessons from "./TeacherDashboard/TeacherDashboardLessons";
import TeacherDashboardPreparations from "./TeacherDashboard/TeacherDashboardPreparations";
import StudentDashboardLessons from "./StudentDashboard/StudentDashboardLessons";
import { AcademicYearProvider } from "./AcademicYearContext";

function DashboardPage() {
  const { userProfile } = useAuth();

  usePageTitle("Dashboard");

  return (
    <AcademicYearProvider>
      <h2>Dashboard</h2>

      <hr />

      {userProfile?.role === "PRINCIPAL" && (
        <>
          <AccountantDashboardLessons />
          <PrincipalDashboard />
        </>
      )}
      {userProfile?.role === "ACCOUNTANT" && <AccountantDashboardLessons />}
      {userProfile?.role === "TEACHER" && (
        <>
          <TeacherDashboardPreparations />
          <TeacherDashboardLessons />
        </>
      )}
      {userProfile?.role === "STUDENT" && (
        <>
          <StudentDashboard />
          <StudentDashboardLessons />
        </>
      )}
    </AcademicYearProvider>
  );
}

export default DashboardPage;
